import {createSlice} from "@reduxjs/toolkit";
import {FAILED, LOADING, SUCCESS} from "../../../common/statuses";
import {getAllStudentHomework, HW} from "./hwService";
import {initialState} from "./initState";

const hwReducer = createSlice({
    name: HW,
    initialState,
    reducers: {
        clearHWState: () => {
            return {...initialState}
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getAllStudentHomework.pending, (state) => {
                state.courses.status = LOADING
            })
            .addCase(getAllStudentHomework.fulfilled, (state, action) => {
                state.courses.status = SUCCESS
                state.courses.mental = action.payload
            })
            .addCase(getAllStudentHomework.rejected, (state) => {
                state.courses.status = FAILED
            })
    }
})

export const {clearHWState} = hwReducer.actions

export default hwReducer.reducer